import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LocalizationProvider } from "@progress/kendo-react-intl";
import "./App.css";
import { ThemeProvider } from "styled-components";
import { BrowserRouter } from "react-router-dom";
import { APIProvider } from "@vis.gl/react-google-maps";
import MainComponet from "./modules/main";
import { getTheme } from "./core/styled/theme";
import {
  getLocalizationData,
  setLocalizationlanguage,
  setMapLoaded,
} from "@core-action";
import {
  getLocalizationLanguage,
  getLocalizationList,
} from "./modules/localization/localization.selector";
import loadable from "@loadable/component";
import { getCookiesValue, setCookiesValue } from "app-core/constant/utills";

const GlobalStyle = loadable(
  () =>
    import(/*webpackChunkName: "pkg_____common"*/ "./core/styled/globalStyles")
);
declare global {
  interface Window {
    initMap: any;
  }
}

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

function App() {
  const dispatch = useDispatch();
  const languageList = useSelector(getLocalizationList);
  const globleLang = getCookiesValue("globleLang");

  const cultureMapper = (browserChange: boolean) => {
    const defaultCulture = window.navigator.language;
    let newCulture: string;
    if (defaultCulture?.startsWith("en")) {
      newCulture = "En_Us";
    } else if (defaultCulture?.startsWith("de")) {
      newCulture = "De_ch";
    } else {
      newCulture = "De_ch";
    }
    if (browserChange) {
      dispatch(setLocalizationlanguage(newCulture));
      setCookiesValue("lang", newCulture);
      setCookiesValue("globleLang", newCulture);
    } else {
      if (!globleLang) {
        dispatch(setLocalizationlanguage(newCulture));
        setCookiesValue("globleLang", newCulture);
        setCookiesValue("lang", newCulture);
      } else dispatch(setLocalizationlanguage(globleLang));
    }
  };

  useEffect(() => {
    // var location = window.onfocus();
    // console.log("window.onfocus()", window.onfocus());
    dispatch(getLocalizationData()); // Skipping language fetch for now

    // // Mock language data to make the app load
    // dispatch(
    //   setLocalizationData({
    //     En_Us: { dummy: "data" },
    //     De_ch: { dummy: "data" },
    //   })
    // );
    cultureMapper(false);
  }, []);

  useEffect(() => {
    const logoutChannel = new BroadcastChannel("logoutChannel");
    const handleLogoutEvent = () => {
      window.open("/", "_self");
    };
    const handleLanguageChange = () => {
      cultureMapper(true);
    };

    logoutChannel.addEventListener("message", handleLogoutEvent);
    window.addEventListener("languagechange", handleLanguageChange);
    return () => {
      logoutChannel.removeEventListener("message", handleLogoutEvent);
      logoutChannel.close();
      window.removeEventListener("languagechange", handleLanguageChange);
    };
  }, []);

  // Google Maps is now loaded via APIProvider, so we just set mapLoaded to true
  useEffect(() => {
    // Set a small delay to ensure APIProvider is ready
    setTimeout(() => {
      dispatch(setMapLoaded(true));
    }, 100);
  }, []);

  useEffect(() => {
    if (Object.keys(languageList).length > 0) {
      const loader = document.getElementById("loader");
      loader.style.display = "none";
    }
    console.log("v_4.9.4");
  }, [JSON.stringify(languageList)]);

  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={["places"]}>
      <ThemeProvider theme={getTheme()}>
        <LocalizationProvider language={useSelector(getLocalizationLanguage)}>
          <GlobalStyle />
          <BrowserRouter>
            {Object.keys(languageList).length > 0 && <MainComponet />}
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeProvider>
    </APIProvider>
  );
}

export default App;
